/**
 * Сборка тела PUT /profiles/:uid/accounts.
 * password и generate_password взаимоисключающи (иначе 422).
 */

/**
 * Политика пароля как в ResetPassword: минимум 8, строчная, заглавная, цифра.
 * @param {string} password
 * @param {string} [confirmPassword]
 * @returns {string} текст ошибки или пустая строка
 */
export function validatePasswordPolicy(password, confirmPassword) {
  const value = String(password || '');
  if (value.length < 8) return 'Минимальная длина пароля — 8 символов';
  if (!/[a-z]/.test(value)) return 'Добавьте хотя бы одну строчную букву';
  if (!/[A-Z]/.test(value)) return 'Добавьте хотя бы одну заглавную букву';
  if (!/[0-9]/.test(value)) return 'Добавьте хотя бы одну цифру';
  if (confirmPassword !== undefined && value !== confirmPassword) {
    return 'Пароли не совпадают';
  }
  return '';
}

/**
 * @param {object} params
 * @param {string} [params.name]
 * @param {string} params.username
 * @param {string} [params.password]
 * @param {boolean} [params.generatePassword]
 * @param {string} [params.inviteEmail]
 * @param {boolean} [params.isActive]
 * @param {string[]} [params.permissionCodes]
 * @returns {object}
 */
export function buildAccountCreatePayload({
  name,
  username,
  password = '',
  generatePassword = false,
  inviteEmail = '',
  isActive = true,
  permissionCodes,
}) {
  const payload = {
    name: String(name || username || '').trim(),
    username: String(username || '').trim().toLowerCase(),
    is_active: Boolean(isActive),
  };

  if (Array.isArray(permissionCodes) && permissionCodes.length > 0) {
    payload.permission_codes = permissionCodes;
  }

  if (generatePassword) {
    payload.generate_password = true;
  } else {
    const pwd = String(password || '');
    if (pwd) {
      payload.password = pwd;
    }
  }

  const email = String(inviteEmail || '').trim().toLowerCase();
  if (email) {
    payload.invite_email = email;
  }

  return payload;
}
